export const errorMesage = "Функциональность приложения ограничена:" +
    " заблокирована возможность подписания документов в приложении" +
    " с помощью электронной подписи. Для разблокировки – обратитесь" +
    " в ОЦО для подписания согласия о переходе на электронный" +
    " документооборот";